import { Dayjs } from 'dayjs';
import { DataModel } from '../models/dto/dto.js';
import { InvoiceProvider } from '../models/serializable/invoicing/invoice-provider.js';

export abstract class InvoiceBase extends DataModel {
  abstract get provider(): InvoiceProvider;
  abstract get uniqueId(): string;
  abstract get name(): string;
  abstract get downloadUrl(): string | null;
  abstract get creationDate(): Dayjs;
}
